import React from 'react'
import { GetParamsData } from '$Deposits/lib/LibCommonData'
import { numberWithCommas } from '$Deposits/lib/LibCommonData'
import { DepositHeader } from '../index'
import TipsView from '../Components/TipsView'
import CopyView from '../Components/CopyView'
import SubmitBtn from '../Components/SubmitBtn'
import Modal from '../Components/Modal'
import html2canvas from 'html2canvas';
const download = require('downloadjs');
import NextStepCon from '$Deposits/Components/BQR/NextStep'
import QRCodeUrlView from '../Components/QRCodeUrlView'




class NextStep extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        };

    }

    componentDidMount() {

    }
    componentWillUnmount() {

    }
    //下載分享圖片
    downloadShareImage = async () => {
        html2canvas(document.querySelector('#qrcode'), { useCORS: true })
            .then((canvas) => {
                download(canvas.toDataURL('image/png'), `QRcode.png`);
                const { toastTip } = GetParamsData()
                toastTip.success('Lưu Mã Thành Công', 2);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    render() {


        return (
            <>
                <NextStepCon
                    PayModal={(propCon) => {
                        const { modalVisible, title, msg, onChange, okText, onCancel } = propCon
                        return (
                            <Modal
                                className='modalTips'
                                visible={modalVisible}
                                title={title}
                                onlyOkBtn={true}
                                isColumn={true}
                                okText={okText}
                                onOk={onChange}
                                onCancel={onCancel}
                            />
                        )
                    }}
                    Modal={(propCon) => {
                        const { modalVisible, title, msg, onChange, okText } = propCon
                        return (
                            <Modal
                                className='modalTips'
                                visible={modalVisible}
                                title={title}
                                onlyOkBtn={true}
                                okText={okText}
                                onOk={onChange}
                            >
                                <>
                                    <div className='titleIcon'>
                                        <span className='warningIcon imgIcon' />
                                    </div>
                                    <p className="intro">{msg}</p>
                                </>
                            </Modal>
                        )
                    }}
                    NextStep={(propCon) => {
                        const {
                            MethodsActive,
                            DepositPayments,
                            DepositMoneyStatus,
                            backClick,
                            onChange,
                        } = propCon

                        const { uniqueAmount, returnedBankDetails, qrDeepLink, offlineRefNo, isDummyBank } = DepositPayments || {}
                        const { accountNumber } = returnedBankDetails || {}
                        const { money } = DepositMoneyStatus || {}
                        return (
                            <>
                                <div className='nextModal'>
                                    <div className='nextModalCenter'>
                                        <div className='viewArea'>
                                            {/* <TipsView msg={'Sau khi chuyển tiền vào tài khoản ngân hàng của FUN88, hãy cung cấp thông tin gửi tiền của bạn cho chúng tôi theo đơn bên dưới để tạo lệnh gửi tiền.'} /> */}

                                            <h4>Thông tin tiền gửi của bạn:</h4>

                                            <div className='amount'>
                                                <span className='amountTitle'>Số Tiền Gửi (1=1,000)</span>
                                                <span className='amountValue'>{numberWithCommas(uniqueAmount)} đ</span>
                                            </div>


                                            <div className='tipsGray'>
                                                Sau khi giao dịch thành công, số tiền <span>{numberWithCommas(money * 1000)}</span> sẽ được cập nhật vào tài khoản của bạn.
                                            </div>

                                            {/* <div className='borders' /> */}
                                        </div>
                                        <div className='viewArea'>
                                            <h4>Ngân Hàng FUN88:</h4>
                                            {/* qrcode */}
                                            {/* <p className='promptMsg'>Quét mã QR để gửi tiền và lưu ý mã QR này chỉ sử dụng được 1 lần duy nhất.</p> */}
                                            {/* qrcode */}
                                            <div className='QD-qrCode' onClick={this.viewShots}>
                                                <div className='QD-qrCode-border'>
                                                    <QRCodeUrlView deepLink={qrDeepLink} />
                                                </div>
                                                <div className='DQ-download' onClick={this.downloadShareImage}>
                                                    Lưu Mã QR
                                                </div>
                                            </div>

                                            {/* 卡号 */}
                                            <CopyView
                                                copyTitle={'Nội Dung Chuyển Tiền'}
                                                copyValue={offlineRefNo}
                                                copyType={'offlineRefNo'}
                                                redTip={true}
                                            />
                                        </div>
                                        <SubmitBtn
                                            onPress={onChange}
                                            submitBtnItem={'Tôi Đã Gửi Tiền Thành Công'}
                                        />
                                        <div className='remarks'>
                                            <h4>Lưu ý chuyển tiền:</h4>
                                            <ol>
                                                <li>Chỉ chấp nhận quét mã QR bằng ứng dụng ngân hàng hoặc bằng ứng dụng ví điện tử Momo Pay hoặc Viettel Pay.</li>
                                                <li>Mã QR chỉ có thể sử dụng 1 lần duy nhất vui lòng không sử dụng lại.</li>
                                                <li>Số điện thoại yêu cầu điền lúc gửi tiền bằng ví điện tử là không bắt buộc (ứng dụng ngân hàng không yêu cầu).</li>
                                            </ol>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )
                    }}
                />

            </>
        );
    }
}

export default NextStep



